<template>
  <ul class="counselorList" :class="addClass">
    <li v-for="menu in excludeList" :key="menu.menu_id" class="counselorList__item">
      <a :href="'/2021_luck/lp/' + menu.menu_id" class="counselorList__link">
        <img :src="`${imgPath}counselor${menu.menu_id}.png`" :alt="menu.name" class="counselorList__img">
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: "counselorList",
  props: {
    list: {
      type: Array,
      default () {
        return []
      }
    },
    imgPath: {
      type: String,
      default: '',
    },
    // 除外したいメニューID
    exclude: {
      type: [Number, String],
      default: null,
    },
    // ちょっとデザインを変えたい時に追加するclass
    addClass: {
      type: String,
      default: '',
    }
  },
  computed: {
    // 指定メニューIDを除いたリストを返す
    excludeList () {
      return this.list.filter((item) => {
        return item.menu_id != this.exclude
      })
    }
  }
}
</script>

<style scoped lang="scss">
.counselorList {
  $root: &;
  margin: -2.34%;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  &__item {
    display: block;
    flex: 1 1 50%;
    max-width: 200px;
    padding: 2.34%;
  }
  &__link {
    transition: 0.3s;
    &:hover {
      opacity: 0.8;
    }
  }
  &__img {
    max-width: 100%;
    vertical-align: middle;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.15);
    border-radius: 9%;
  }
  &--result {
    justify-content: start;
    #{$root}__item {
      flex: 1 1 33.33%;
      max-width: 33.33%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2021/counselorList.vue